import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MachineProvider } from "./context/MachineContext";
import { DepartmentProvider } from "./context/DepartmentContext";
import MonitoringPage from "./pages/MonitoringPage";
import DashboardPage from "./pages/DashboardPage";
import NotFoundPage from "./pages/NotFoundPage";
import ReportsPage from "./pages/ReportsPage";
import MachineDetailsPage from "./pages/MachineDetailsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import MachinesPage from "./pages/management-pages/MachinesPage";
import LicensesPage from "./pages/management-pages/LicensesPage";
import DepartmentsPage from "./pages/management-pages/DepartmentsPage";
import UsersPage from "./pages/management-pages/UsersPage";
import { UserProvider } from "./context/UserContext";
import CompanyPage from "./pages/management-pages/CompanyPage";
import WorkingHoursPage from "./pages/WorkingHoursPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const [user, setUser] = useState(null);
  const apiUrl = process.env.REACT_APP_MONGO_URL;


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetch(`${apiUrl}/api/users/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => res.json())
        .then((data) => setUser(data))
        .catch(() => localStorage.removeItem("token"));
    }
  }, [apiUrl]);

  return (
    <UserProvider>
      <DepartmentProvider>
        <MachineProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<ProtectedRoute user={user} />}>
                <Route path="" element={<DashboardPage />} />
              </Route>
              {/* <Route path="/" element={<DashboardPage />} /> */}
              <Route path="/monitoring" element={<MonitoringPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/workingHours" element={<WorkingHoursPage />} />
              <Route
                path="/machines/:machineId"
                element={<MachineDetailsPage />}
              />
              <Route path="management/machines" element={<MachinesPage />} />
              <Route
                path="management/departments"
                element={<DepartmentsPage />}
              />
              <Route path="management/users" element={<UsersPage />} />
              <Route path="management/company" element={<CompanyPage />} />
              <Route path="management/licenses" element={<LicensesPage />} />
              <Route path="/login" element={<LoginPage setUser={setUser} />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </MachineProvider>
      </DepartmentProvider>
    </UserProvider>
  );
}

export default App;
